/* src/app/components/doc-viewer-new/dialogs/doc-viewer-dialog/doc-viewer-dialog.component.scss */
.close-button,
.dialog-header {
  color: #000;
}
:host-context(.dark-theme) .close-button,
:host-context(.dark-theme) .dialog-header {
  color: #fff;
}
.dialog-header {
  border-bottom: 1px solid #dadada;
}
.close-button {
  border-left: 1px solid #dadada;
}
::ng-deep .doc-viewer-dialog .mat-mdc-dialog-container {
  padding: 0;
  border-radius: 0;
}
::ng-deep .doc-viewer-dialog .mat-mdc-dialog-content {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2117647059);
}
:host-context(.dark-theme) .dialog-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2117647059);
}
:host-context(.dark-theme) .close-button {
  border-left: 1px solid rgba(255, 255, 255, 0.2117647059);
}
:host-context(.dark-theme) ::ng-deep .mat-mdc-dialog-content {
  background: #2e2e2e;
  color: #FFF;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2117647059);
}
/*# sourceMappingURL=doc-viewer-dialog.component.css.map */
